import FlagDe from '@/assets/flags/de.webp';
import FlagEn from '@/assets/flags/en.webp';
import FlagFr from '@/assets/flags/fr.webp';
import FlagNl from '@/assets/flags/nl.webp';
import { Modal } from '@/components/Modal';
import { useLanguage } from '@/hooks/UseLanguage';
import { Lang } from '@/types/user';
import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';

interface LanguageModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const LanguageModal = ({ isOpen, onClose }: LanguageModalProps) => {
  const { i18n, t } = useTranslation();
  const { changeLanguage } = useLanguage();

  const handleLanguageChange = (lang: Lang) => {
    changeLanguage(lang);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('languageModal:title')}>
      <ul className="flex flex-row items-center justify-center gap-2">
        {i18n.options.supportedLngs ? (
          i18n.options.supportedLngs
            .filter(lang => lang !== 'cimode')
            .map(lang => (
              <li
                key={lang}
                className={cn(
                  `cursor-pointer rounded p-2 hover:bg-gray-light ${
                    i18n.language === lang ? 'bg-gray-light' : ''
                  }`,
                )}
                onClick={() => handleLanguageChange(lang as Lang)}
              >
                <img
                  src={
                    {
                      fr: FlagFr,
                      nl: FlagNl,
                      en: FlagEn,
                      de: FlagDe,
                    }[lang]
                  }
                  alt={lang}
                  width={50}
                  height={50}
                />
              </li>
            ))
        ) : (
          <li className="text-danger">No supported languages available</li>
        )}
      </ul>
    </Modal>
  );
};
